import type { Graphics as PixiGraphicsObject } from 'pixi.js';
import { useCallback } from 'react';

import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import type { Offset } from 'flow-builder/utils/text/baseTextParser/baseTextParser';

type Tag = {
  color?: string | null;
};

export type DrawTagCircle = (
  tag: Tag | undefined,
  position: Offset,
) => (graphics: PixiGraphicsObject) => void;

export const useDrawTagCircle: DrawTagCircle = (tag, offset) =>
  useCallback(
    (graphics) => {
      if (!tag?.color) {
        return;
      }

      graphics.clear();
      graphics.beginFill(hexStringToNumber(tag.color));
      graphics.drawCircle(offset.x, offset.y, 5);
      graphics.endFill();
    },
    [tag, offset.x, offset.y],
  );
